<template>
  <modal
    size="lg"
    v-bind="$attrs"
  >
    <div class="text-right">
      <a
        class="text-danger mt-2 mr-2"
        @click="$emit('close')"
      >
        <i class="fa fa-times fa-lg" />
      </a>
    </div>

    <div class="pt-2 pb-3 px-md-5">
      <h5 class="text-center mb-4">
        {{ $t('manage-master-data.work-statuses.create-work-status') }}
      </h5>

      <div class="form-group">
        <label>
          <small class="font-weight-bold">
            {{ $t('manage-master-data.work-statuses.work-status-name') }} (ID)
          </small>
        </label>
        <input
          v-model="workStatus.nameID"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': $v.workStatus.nameID.$error }"
        >
        <div
          v-if="!$v.workStatus.nameID.required && $v.workStatus.nameID.$error"
          class="text-danger"
        >
          <small>
            {{
              $t(
                'manage-master-data.work-statuses.error.required',
                { name: `${$t('manage-master-data.work-statuses.work-status-name')} (ID)` }
              )
            }}
          </small>
        </div>
        <div
          v-if="Object.keys(error).length"
          class="text-danger"
        >
          <small>
            {{ $i18n.locale === 'en' ? error.messageEng : error.messageIdn }}
          </small>
        </div>
      </div>

      <div class="form-group">
        <label>
          <small class="font-weight-bold">
            {{ $t('manage-master-data.work-statuses.work-status-name') }} (EN)
          </small>
        </label>
        <input
          v-model="workStatus.nameEN"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': $v.workStatus.nameEN.$error }"
        >
        <div
          v-if="!$v.workStatus.nameEN.required && $v.workStatus.nameEN.$error"
          class="text-danger"
        >
          <small>
            {{
              $t(
                'manage-master-data.work-statuses.error.required',
                { name: `${$t('manage-master-data.work-statuses.work-status-name')} (EN)` }
              )
            }}
          </small>
        </div>
        <div
          v-if="Object.keys(error).length"
          class="text-danger"
        >
          <small>
            {{ $i18n.locale === 'en' ? error.messageEng : error.messageIdn }}
          </small>
        </div>
      </div>

      <div class="form-group">
        <label>
          <small class="font-weight-bold">
            {{ $t('manage-master-data.work-statuses.company') }}
          </small>
        </label>
        <v-select
          v-model="workStatus.companyId"
          class="sm"
          label="name"
          :options="companies"
          :reduce="reducer"
        />
      </div>

      <div class="form-group">
        <label>
          <small class="font-weight-bold">
            {{ $t('manage-master-data.work-statuses.organization') }}
          </small>
        </label>
        <v-select
          v-model="workStatus.workLocationId"
          class="sm"
          label="name"
          :options="workLocations"
          :reduce="reducer"
        />
      </div>

      <div class="text-center mt-5">
        <button
          class="btn btn-info btn-sm p-2 font-weight-bold"
          :disabled="isSaving"
          @click="save"
        >
          <div
            v-if="isSaving"
            class="spinner-border spinner-border-sm text-light"
          />
          <div v-else>
            {{ $t('manage-master-data.save') }}
          </div>
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VSelect from 'vue-select'
import api from '@/utils/Api'
import Modal from '@/components/Modal'

export default {
  components: {
    VSelect,
    Modal
  },

  props: {
    workStatus: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    companies: [],
    workLocations: [],
    isSaving: false,
    error: {}
  }),

  created () {
    this.fetchCompanies()
    this.fetchWorkLocations()
  },

  methods: {
    async fetchCompanies () {
      const { data } = await api.masterData.companies()
      this.companies = data.data
    },
    async fetchWorkLocations () {
      const { data } = await api.masterData.workLocations()
      this.workLocations = data.data
    },
    async save () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.isSaving = true
      try {
        const {
          nameEN,
          nameID,
          companyId,
          workLocationId
        } = this.workStatus
        await api.workStatuses.update(this.workStatus.id, {
          nameEN,
          nameID,
          companyId,
          workLocationId
        })
        this.$emit('saved')
        this.error = {}
      } catch ({ response }) {
        this.error = response.data.message
      } finally {
        this.isSaving = false
      }
    },
    reducer: ({ id }) => id
  },

  validations: {
    workStatus: {
      nameEN: {
        required
      },
      nameID: {
        required
      }
    }
  }
}
</script>
